export function formatCnae(cnae: string): string {
  if (!cnae || typeof cnae !== 'string') return '';
  const digitsOnly = cnae.replace(/\D/g, '');
  if (digitsOnly.length !== 7) {
    return cnae; // Return original if not a 7-digit string
  }
  return `${digitsOnly.slice(0, 4)}-${digitsOnly.slice(4, 5)}/${digitsOnly.slice(5, 7)}`;
}

export function stripCnaeFormat(cnae: string): string {
  if (!cnae || typeof cnae !== 'string') return '';
  return cnae.replace(/\D/g, '');
}
